import { render } from "./IconPointDefault.vue?vue&type=template&id=136db3d2&ts=true"
import script from "./IconPointDefault.vue?vue&type=script&lang=ts"
export * from "./IconPointDefault.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__